import axios from 'axios'

import { environment } from '@/shared/consts/environment'
import './axiosAuthMiddleware'
import { errorMiddleware } from './errorMiddleware'
import { IUser } from '@/interfaces/user'
import { IRecommendation } from '@/interfaces/recommendation'

const apiUrl = `${environment.apiUrl}/api/v1/users/connections`

/**
 * ----------------------------------------
 * Create
 * ----------------------------------------
 */

// --- create connection
export const createConnection = async (id: string) => {
  try {
    const res = await axios.patch<null, { data: IUser }>(`${apiUrl}/complete`, {
      userIdReceivedRequest: id,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const requestConnection = async (id: string, message?: string) => {
  try {
    const res = await axios.patch<null, { data: IUser }>(`${apiUrl}/request`, {
      userIdReceivedRequest: id,
      message,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const blockConnection = async (id: string, reason?: string) => {
  try {
    const res = await axios.patch<null, { data: IUser }>(`${apiUrl}/block`, {
      blockedUserId: id,
      reason,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const unblockConnection = async (id: string) => {
  try {
    const res = await axios.patch<null, { data: IUser }>(`${apiUrl}/unblock`, {
      unblockedUserId: id,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const inviteContact = async (contact: IRecommendation) => {
  try {
    const res = await axios.post<null, { data: IUser }>(
      `${apiUrl}/invite-contact`,
      contact
    )
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const processAcceptedInviteExistingUser = async ({
  invitedUserToken,
}: {
  invitedUserToken: string
}) => {
  try {
    const res = await axios.post<null, { data: IUser }>(
      `${apiUrl}/processAcceptedInviteExistingUser?invitedUserToken=${invitedUserToken}`
    )
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

/**
 * ----------------------------------------
 * Update
 * ----------------------------------------
 */

/**
 * ----------------------------------------
 * Delete
 * ----------------------------------------
 */
export const declineConnection = async (id: string) => {
  try {
    const res = await axios.patch<null, { data: IUser }>(`${apiUrl}/decline`, {
      userIdReceivedRequest: id,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const deleteConnection = async (id: string) => {
  try {
    const res = await axios.patch<null, { data: IUser }>(`${apiUrl}/delete`, {
      userIdReceivedRequest: id,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

// invite users to connect
// https://creatorland-backend-360321061826.us-central1.run.app we use this route temporary for the testing
export const sendDealSyncInvites = async (emailString: string) => {
  try {
    const res = await axios.post(`${apiUrl}/dealsync-invite-contacts`, {
      emailString,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
